import * as VendorReducer from '../Vendor.reducer';
import { waitForVendor } from '../Vendor.saga';

const VENDOR = 'optimizely';

export const isAvailable = state => VendorReducer.isAvailable(state, VENDOR);
export const setAvailable = VendorReducer.setAvailable.bind(null, VENDOR);
export const setLoading = VendorReducer.setLoading.bind(null, VENDOR);
export const waitForOptimizely = waitForVendor.bind(null, VENDOR);
